__turbopack_context__.v({
  "active": "modal-module__fns3lG__active",
  "blok-big-title": "modal-module__fns3lG__blok-big-title",
  "blok-subtitle": "modal-module__fns3lG__blok-subtitle",
  "blok-title": "modal-module__fns3lG__blok-title",
  "container": "modal-module__fns3lG__container",
  "hidden": "modal-module__fns3lG__hidden",
  "menu": "modal-module__fns3lG__menu",
  "mobile-overlay": "modal-module__fns3lG__mobile-overlay",
  "scrolled": "modal-module__fns3lG__scrolled",
});
